import {Injectable, Inject, PLATFORM_ID, EventEmitter} from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageManager } from 'src/app/data/manager/local-storage/local-storage.manager';
import { countryConfig } from 'src/country-config/country-config';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { UpdateScanAndGoModalEvent } from 'src/app/ui/shared/event-listeners/update-scan-and-go-modal/update-scan-and-go-modal.event';

declare const window:any;
declare const JSBridge:any;

const fbDataBase = countryConfig.general.sag.urlSAG;
const table = 'userStatus';
const userStatusPath = `${table}/store-id-`;


@Injectable({
  providedIn: 'root',
})
export class MobileConnectorService {

  device: string;
  bridgeActive;
  isBrowser: any;
  sagSubscriptions: any = {};
  sagModalStatus: any = {open: false};
  clearSearchBar: EventEmitter<any> = new EventEmitter();
  private fullsreen = false;


  @Select(state => state.scanAndGoStore) scanAndGoStore$: Observable<any>;

  get isWeb() {
    return  (window.location.host.indexOf("farmatodo.com.ve") > -1);
  }

  get customer() : any { return JSON.parse(window.localStorage?.customer || '{}'); }

  get isMobile() {
    if(this.isWeb) { return false; }
    return ['ANDROID', 'IOS']
      .findIndex((d)=> d === this.device) > -1;
  }

  get isAndroid() {
    return this.device == 'ANDROID';
  }

  get isIOS() {
    return this.device == 'IOS';
  }

  mobilSag(sw: boolean) {
    this.lsm.set('mobileSaG', sw);
  }

  constructor(
    private router: Router,
    private lsm: LocalStorageManager,
    private modalStatusEvent: UpdateScanAndGoModalEvent,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
  }

  deviceInit() {
    if(!this.isWeb && this.isBrowser) {
      this.nativeEventSubscriptions();
      this.monitorScanAndGo();
      setTimeout(() => {
        if (localStorage.customer && JSON.parse(localStorage.customer).id) {
          const customerJson = {
            id: JSON.parse(localStorage.customer).id,
            idCustomerWebSafe: JSON.parse(localStorage.customer).idCustomerWebSafe,
            token: JSON.parse(localStorage.customer).token.token,
            tokenIdWebSafe: JSON.parse(localStorage.customer).token.tokenIdWebSafe,
          };
          this.onUserLogged(customerJson);
        }
      }, 3000);
    }
  }

  setDevice(device: string) {
    this.device = device;
    this.lsm.set('webview', device);
  }

  monitorScanAndGo() {
    this.onScanAndGoModalEvent();
    let storeId;
    let sagStore;
    this.sagSubscriptions.store = this.scanAndGoStore$
      .pipe(
      )
      .subscribe(store => {
        if (!this.customer || this.customer.isAnonymous) { return; }
        if (store?.config && store.config?.storeId !== storeId) {
          storeId = store.config.storeId;
        }
        if (store.firebase) {
          this.updateFirebase({source: 'WEB'}, storeId);
          if (store.firebase.status !== sagStore?.firebase?.status) {
            this.updateFirebase({status: store.firebase.status}, storeId);
          }
          if (store.firebase.active !== sagStore?.firebase?.active) {
            this.updateFirebase({active: store.firebase.active}, storeId);
          }
          if (store.firebase.review === false) {
            this.closeSaGModal();
          }
          if (store.firebase.reload_cart !== sagStore?.firebase?.reload_cart) {
            this.updateFirebase({reload_cart: store.firebase.reload_cart}, storeId);
          }
        }
          sagStore = {...store};
      });
  }

  updateFirebase(data, storeId) {
    const month = (`0${new Date().getMonth() + 1}`).slice(-2);
    const year = new Date().getFullYear();
    const day = (`0${new Date().getDate()}`).slice(-2);
    `${month}/${day}/${year}, ${this.formatAMPM(new Date())}`;
  }

  closeSaGModal() {
    this.sagModalStatus = {close: true};
  }

  onScanAndGoModalEvent() {
    this.modalStatusEvent.updatedModalStatus.subscribe(status => {
      if (status) {
        this.sagModalStatus = status;
      }
    });
  }

  logPurchase(idOrder:string) {
    this.sendData('logPurchase', idOrder);
  }

  logSignUp(provider: string) {
    this.sendData('logSignUp', provider);

  }

  fullscreenMode(sw = false) {
    const navbar = document.getElementById('header');
    const p2cHomebar = document.getElementById('p2cHomebar');
    const menubottom = document.getElementById('mobile-menu-bottom')
    if(sw) {
      if(navbar) navbar.style.display = 'none';
      if(p2cHomebar) p2cHomebar.classList.add('barHidden');
      if(menubottom) menubottom.style.display = 'none';
      document.getElementById('app-component-router-outlet').style['max-height'] ='100vh';
    } else {
      if(navbar) navbar.style.display = 'inline';
      if(p2cHomebar) p2cHomebar.classList.remove('barHidden');
      if(menubottom) menubottom.style.display = 'block';
      if(!this.isIOS) {
        document.getElementById('app-component-router-outlet').style['max-height'] ='calc(100vh - 160px)';
      }
    }
    this.fullsreen = sw;
  }

  get isFullscreenMode(){ return this.fullsreen; }

  onLogin(data: any) {

  }

  onUserLogged(data: any) {
    if (this.device == 'IOS') {
      this.sendIosData(data);
    } else {
      this.sendData('onUserLogged', data);
    }
  }

  nativeMobileCam(data: any) {
    this.sendData('nativeMobileCam', data);

  }

  navigateToSag(data: any) {
    this.sendData('navigateToSag', data);
  }

  onNavigateToSagQR() {
    this.sendData('onNavigateToSagQR');
  }

  private sendData(method:string, data:any = null) {
    if (this.isAndroid) {
      this.sendAndroidData(method, data);
    }
    else if (this.isIOS) {
      this.sendIosData(!data ? method : {[method]:data});
    }
  }

  private sendAndroidData(method: string, data: any) {
    try {
      if(data == null) {
        JSBridge[method]();
      } else {
        const dat = (typeof data == 'string') ? data : JSON.stringify(data);
        JSBridge[method](dat);
      }
    } catch (error) {
      console.log('@error:', ` Fallo invocando metodo: ${method}(${data}) [ANDROID]`);
      if(method == 'navigateToSag'){
        this.router.navigate(['/escanea-y-listo/inicio']);
      }
    }
  }

  private sendIosData(data:any = null) {
    try{
      window.webkit.messageHandlers.jsMessageHandler.postMessage(data);
    } catch(e) {
      return false;
    }
  }


  nativeEventSubscriptions() {
    window.navigateToCart = () => {
      this.lsm.set('mobileSaG', true);
      this.router.navigateByUrl('/carrito?deliveryType=SCANANDGO');
      return false;
    }
  }

  private formatAMPM(date) {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const seg = date.getSeconds();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours %= 12;
    hours = hours || 12;
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    const strTime = `${hours}:${minutes}:${seg} ${ampm}`;
    return strTime;
  }

}
const style = 'color:green;font-weight:600;font-size:9pt';
